import { render, staticRenderFns } from "./view-contact.vue?vue&type=template&id=78f1a7b3&scoped=true&"
import script from "./view-contact.vue?vue&type=script&lang=js&"
export * from "./view-contact.vue?vue&type=script&lang=js&"
import style0 from "./view-contact.vue?vue&type=style&index=0&id=78f1a7b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f1a7b3",
  null
  
)

export default component.exports